import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { listTableRemoveData } from 'gnos-tables'

import { activeTab, removeData as removeTabsData } from '../../../../../../../../../components/Tabs/actions'

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ activeTab, listTableRemoveData, removeTabsData }, dispatch)
}

export default function (InnerComponent) {
    @connect(null, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
